setTimeout(function () {
  let maxSlideHeight = 0
  $(".section-solutions .slides .slide").css("--height", "auto")
  $(".section-solutions .slides .slide").each(function () {
    const h = $(this).height()
    if (h > maxSlideHeight) {
      maxSlideHeight = h
    }
  })
  const slideMenuHeight = $(".section-solutions .menu").height()
  if (maxSlideHeight < slideMenuHeight) {
    maxSlideHeight = slideMenuHeight
  }
  $(".section-solutions .slides").css("--height", maxSlideHeight + "px")
  setTimeout(function () {
    $(".section-solutions .slides .slide").css(
      "--height",
      maxSlideHeight + "px",
    )
  }, 100)
}, 500)

$(".section-solutions .menu > li > a").on("click", function (e) {
  e.preventDefault()
  const id = $(this).data("id")
  $(".section-solutions .menu > li.active").removeClass("active")
  $(this).parent().addClass("active")
  $(".section-solutions .slides .slide.active").removeClass("active")
  $(".section-solutions .slides .slide.slide-" + id).addClass("active")
  $(".section-solutions").css(
    "--bg",
    $(".section-solutions .slides .slide.active").css("--bg"),
  )
})
$(".section-solutions .menu > li:first > a").trigger("click")

$(".solutions-dropdown .dropdown-menu .dropdown-item").on(
  "click",
  function (e) {
    e.preventDefault()
    const id = $(this).data("id")
    $(".section-solutions .slides .slide.active").removeClass("active")
    $(".section-solutions .slides .slide.slide-" + id).addClass("active")
    $(".solutions-dropdown > .btn").html($(this).html())
  },
)
$(".solutions-dropdown .dropdown-menu .dropdown-item:first").trigger("click")
